import { SHARABLE_RESOURCE_TYPES } from '../team-and-sharing/constants';
import { FEATURES, PERMISSION_NOT_ALLOWED } from '/src/features/_global/constants';

export const WEB_ANALYTICS_PERMISSIONS = {
  [FEATURES.WEB_ANALYTICS]: ({ capabilities, isSharing, sharedResource }) => {
    const sharedResourceIsSource =
      [SHARABLE_RESOURCE_TYPES.WEB_ANALYTICS_SITE, SHARABLE_RESOURCE_TYPES.WEB_ANALYTICS_GA_PROPERTY].includes(
        sharedResource?.resource?.resourceType,
      ) && parseInt(sharedResource?.resource?.resourceId) === parseInt(sharedResource?.resource?.source?.id);

    if (isSharing) {
      return {
        navigate: PERMISSION_NOT_ALLOWED,
        view: sharedResourceIsSource ? { allowed: true } : PERMISSION_NOT_ALLOWED,
        edit: PERMISSION_NOT_ALLOWED,
        share: PERMISSION_NOT_ALLOWED,
      };
    }

    return {
      navigate: capabilities?.webAnalytics.permissions.nav,
      view: capabilities?.webAnalytics.permissions.view,
      edit: capabilities?.webAnalytics.permissions.edit,
      share: capabilities?.webAnalytics.permissions.edit,
    };
  },
};
